export * from '@primeuix/themes/nora/treeselect';
export { default } from '@primeuix/themes/nora/treeselect';
